import { getTravellersTypes } from '../utils';
import { DataLayerService } from '../OrderDataLayer/types';
import { ItemCategory } from '../types';
import {
	CheckinPassengerFragment,
	GdsService_OrderAdditionalServiceGdsServicePriceFreeze_Fragment,
	PassengerFragment
} from '@websky/graphql';

export const getHoldDatalayerItem = (
	freezeService: GdsService_OrderAdditionalServiceGdsServicePriceFreeze_Fragment,
	travellers: PassengerFragment[] | CheckinPassengerFragment[]
): DataLayerService => {
	return {
		name: 'hold',
		category: ItemCategory.PriceFreeze,
		price: freezeService.price.amount * freezeService.allowedPassengers.length,
		forAllSegments: true,
		count: 1,
		travellersTypes: getTravellersTypes(travellers)
	};
};
